import AnimatedNumber from '@components/Animation/AnimatedNumber';
import styled from '@emotion/styled';
import {colors} from '@styles/colors';
import {fontWeight, mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';

export const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AbsenceInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: left;
  padding-bottom: 20px;
`;

export const StudentAbsence = styled(AnimatedNumber)`
  font-size: 78px;
  line-height: 1;
  color: ${colors.mainTextColor};
  font-weight: ${fontWeight.bold};
  justify-self: flex-end;

  @media (max-width: 1920) {
    font-size: 4.8vw;
  }

  ${mq(Devices.laptop)} {
    font-size: 48px;
  }

  ${mq(Devices.tablet)} {
    font-size: 36px;
  }
`;

export const ChartTitle = styled.div`
  font-size: 18px;
  color: ${colors.gray};
  font-weight: ${fontWeight.regular};

  ${mq(Devices.laptop)} {
    font-size: 14px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 40px;

  ${mq(Devices.laptop)}{
    padding-top: 20px;
  }

  ${mq(Devices.mobile)}{
    padding-top: 20px;
  }
`;

export const LoaderWrapper = styled.div`
  position: relative;
  height: var(--site-height);
  width: 100%;
`;
